import { List } from "models/list";
import { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { adminDoGetLists } from "services/admin/list";

const AdminRootView = () => {
  const [lists, toggleLists] = useState<List[]>([]);
  const [ready, toggleReady] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      const lists = await adminDoGetLists();
      toggleLists(lists);
      toggleReady(true);
    };
    fetch();
  }, []);

  if (!ready) {
    return null;
  }

  // if no lists (or rather, no access to one)
  if (lists.length === 0) {
    return <Navigate to={`/admin/profile`} />;
  }

  // take the first
  return <Navigate to={`/admin/list/${lists[0].uuid}`} />;
};

export default AdminRootView;
